<template>
  <div class="signUpFormContainer">
    <a href="/"><Logo class="logo" /></a>
    <section class="signUpForm">
      <form @submit.prevent="handleSubmit">
        <div class="signUpFormHeader field">
          <h1 class="pb-2">Joining Itereo is easy.</h1>
        </div>
        <BaseInput
          v-model="formChild.name"
          custom-size="xlarge"
          type="text"
          placeholder="Enter your first name"
          label="Your Name *"
          required
          class="field"
          @blur.native="$v.formChild.name.touch()"
        />
        <div class="mb-4">
          <span>Countries (Optional)</span>
          <multiselect
            v-model="formChild.countries"
            :options="countries"
            :multiple="true"
            tag-position="top"
            :max-height="100"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :allow-empty="true"
            placeholder="Enter countries to use"
            track-by="location_label"
            label="location_label"
          >
          </multiselect>
        </div>
        <BaseInput
          v-model="formChild.email"
          custom-size="xlarge"
          type="email"
          placeholder="some@example.com"
          required
          label="Your Email*"
          class="field"
        />
        <BaseInputPassword
          v-model="formChild.password"
          custom-size="xlarge"
          placeholder="Enter your password"
          required
          label="Password*"
          class="field"
        />
        <BaseInputPassword
          v-model="formChild.password_confirmation"
          custom-size="xlarge"
          placeholder="Confirm your password"
          required
          label="Password Confirmation*"
          class="field"
        />
        <b-field>
          <BaseButton
            :disabled="disabledButton"
            :loading="loading"
            size="xlarge"
            ><p slot="text">Register</p>
            <p
          /></BaseButton>
        </b-field>
        <b-field class="field-newAccount">
          <span>Already have an account? <a href="/">Sign In</a></span>
        </b-field>
      </form>
    </section>
  </div>
</template>

<script>
import Logo from "@/components/_shared/Logo.vue";
import BaseInput from "@/components/base-ui/BaseInput.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import BaseInputPassword from "@/components/base-ui/BaseInputPassword.vue";
import BaseSelect from "@/components/base-ui/BaseSelect.vue";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  name: "FreeSignUp",
  components: {
    Multiselect,
    BaseSelect,
    BaseInputPassword,
    BaseButton,
    BaseInput,
    Logo,
  },
  props: {
    form: {
      type: Object,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      formChild: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        role: 2,
        countries: [],
      },
    };
  },
  mounted() {
    this.$store.dispatch("locations/listCountry");
  },
  computed: {
    ...mapGetters({
      countries: "locations/listCountry",
    }),
    disabledButton() {
      return (
        this.formChild.name === "" ||
        this.formChild.email === "" ||
        this.formChild.password === "" ||
        this.formChild.password !== this.formChild.password_confirmation
      );
    },
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      const response = await this.$store.dispatch(
        "users/registerUser",
        this.formChild
      );
      if (response) {
        this.$buefy.toast.open({
          duration: 5000,
          message: response.message,
          position: "is-top",
          type: "is-success",
        });

        this.login({
          email: this.formChild.email,
          password: this.formChild.password,
        });
      } else this.loading = false;
    },
    login(credentials) {
      this.$store
        .dispatch("auth/getToken", credentials)
        .then(async () => {
          await this.$router.replace(
            this.$route.query.redirect || { name: "home" }
          );
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.errorToast();
          this.form = {};
          console.info(err);
        });
    },
  },
};
</script>

<style scoped>
.signUpFormContainer {
  padding-top: 1rem;
}
.logo {
  height: 3.5rem;
  object-fit: contain;
}
.signUpForm {
  background: white;
  border-radius: 15px;
  padding: 10px 59px;
  width: 38rem;
  margin: 5% 0;
}
.signUpFormHeader {
  display: flex;
  flex-direction: column;
}
form {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;
}
form .field {
  margin-bottom: 1.5rem;
}
.InputsContainerName {
  display: flex;
  justify-content: space-between;
}
.InputsContainerName .field {
  width: 48%;
}
.field-password a {
  text-align: end;
  font-size: 13px;
  line-height: 15px;
  padding-bottom: 0.2rem;
}
.field-newAccount {
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
}
.field-newAccount a {
  text-decoration: underline;
  color: var(--info-color);
  font-weight: 500;
}
.field-newAccount a:hover {
  text-decoration: underline;
  font-weight: 600;
  color: var(--info-color);
}
.field-newAccount span {
  font-weight: 400;
}
h4 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
}
h1 {
  font-size: 35px;
  font-weight: 600;
  line-height: 52px;
}
.icon-eye {
  position: relative;
  bottom: 35%;
  left: 90%;
}
</style>

<style>
.signUpForm .field input {
  padding: 10px !important;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
